import React, { useEffect, useMemo, useState } from 'react';
import { Table, Input, Row, Col, message } from 'antd';

import { withRouter, Link } from 'react-router-dom';

import Loading from '$app/shared/components/Loading';
import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';
import { fetchProducts, getErrorMessage } from '../../productApi';

function ProductListPage({ history }) {
  const [operations, setOperations] = useState(null);
  const [filterProduct, setFilterProduct] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadProducts = async () => {
      try {
        const nextOperations = await fetchProducts();
        if (isMounted) {
          setOperations(nextOperations);
        }
      } catch (error) {
        message.error(getErrorMessage(error));
        if (isMounted) {
          setOperations([]);
        }
      }
    };

    loadProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  const filteredOperations = useMemo(() => {
    if (!operations) {
      return operations;
    }

    if (!filterProduct) {
      return operations;
    }

    return operations.filter((operation) =>
      ['label_mechanic', 'label_customer', 'categories', 'search_terms'].reduce(
        (matches, field) =>
          matches || (operation[field] || '').toLowerCase().includes(filterProduct.toLowerCase()),
        false
      )
    );
  }, [filterProduct, operations]);

  if (!operations) {
    return <Loading />;
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'product_number',
      sorter: (a, b) => a.product_number - b.product_number,
    },
    {
      title: 'Defaut label',
      dataIndex: 'label_mechanic',
      sorter: (a, b) => (a.label_mechanic || '')?.localeCompare(b.label_mechanic),
    },
    {
      title: 'Customer label',
      dataIndex: 'label_customer',
      sorter: (a, b) => (a.label_customer || '')?.localeCompare(b.label_customer),
    },
    {
      title: 'Category',
      dataIndex: 'categories',
      sorter: (a, b) => (a.categories || '')?.localeCompare(b.categories),
    },
    {
      title: 'Search Terms',
      dataIndex: 'search_terms',
    },
  ];

  return (
    <Container>
      <Header>
        <Row justify="space-around" align="middle">
          <Col span={6}>
            <Title>Products</Title>
            <Link to="/new">Create new product</Link>
          </Col>
          <Col span={18} style={{ textAlign: 'right' }}>
            <Input.Search
              placeholder="Search"
              onChange={(e) => setFilterProduct(e.target.value)}
              style={{ width: 200 }}
              defaultValue=""
            />
          </Col>
        </Row>
      </Header>
      <Table
        size="small"
        rowKey={(record) => record.sku}
        pagination={{ pageSize: 100, hideOnSinglePage: true }}
        dataSource={filteredOperations}
        columns={columns}
        onRow={({ sku }) => ({
          onClick: () => history.push(`edit/${sku}`),
        })}
      />
    </Container>
  );
}

export default withRouter(ProductListPage);
